/*
	Generated on 10/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React from 'react';
import { Link, useNavigate } from "react-router";
import { useParams } from "@/commons/hooks/useParams"

import { useAuth } from '@/commons/auth';
import { Button, Modal,Spinner } from '@/commons/components';

import * as Layouts from "@/commons/layouts";

const PenggunaanTable = ({ penggunaanRuanganDataList, ruanganSelectionField,
	}) => {
  const { checkPermission } = useAuth();
  
  
  
  
  
  
  return (
  <>
    <Layouts.ListComponentTableLayout
  	  items={[penggunaanRuanganDataList]}
  	  filterFields={[
  	    {
  	      label: "Ruangan",
  	      featureName: "nama",
  	      options: ruanganSelectionField,
            editable: false,
  	    }
  	  ]}
  	  itemsAttrs={[
          {
            id: "ruangan",
            condition: "",
            label: "Ruangan",
  		  featureName: "nama",
            editable: false
          }
  ,
          {
            id: "kapasitas",
            condition: "",
            label: "Kapasitas",
  		  featureName: "kapasitas",
            editable: false
          }
  ,
          {
            id: "kodeMK",
            condition: "",
            label: "Kode MK",
  		  featureName: "mataKuliahKode",
            editable: false
          }
  ,
          {
            id: "kurikulum",
            condition: "",
            label: "Kurikulum",
  		  featureName: "kurikulumNama",
            editable: false
          }
  ,
          {
            id: "namaMK",
            condition: "",
            label: "Nama MK",
  		  featureName: "mataKuliahNama",
            editable: false
          }
  ,
          {
            id: "namaKelas",
            condition: "",
            label: "Nama Kelas",
  		  featureName: "kelasNama",
            editable: false
          }
  ,
          {
            id: "jadwal",
            condition: "",
            label: "Jadwal",
  		  featureName: "jadwal",
            editable: false
          }
  ,
  ]}
  	/>
  </>
  )
};

export default PenggunaanTable;
